import axios from 'axios';

export function submitItemRequest(request) {
  return new Promise(function(resolve, reject) {
    axios.post(process.env.API_URL+'/item',JSON.stringify(request), {
      headers: {
        'Content-Type': 'application/json',
      }

    })
      .then(function(response) {
        let data = response.data;
        resolve(data);
      })
      .catch(function(err){
        reject(err);
      })
  })

}


export function getNewItem() {
  let item = {
    id:0,
    code:'',
    sender:'',
    senderPostCode:'',
    senderAddress1:'',
    senderAddress2:'',
    senderEmail:'',
    senderContact:'',
    dispatchDate:'',

    receiver:'',
    receiverContact:'',
    postCode:'',
    address1:'',
    address2:'',
    customNumber:'',
    email:'',

    volumeX:0,
    volumeY:0,
    volumeZ:0,

    volumeWeight:0,
    weight:0,
    measuredWeight:0,

    basePrice:500,
    addPrice:100,

    estimatedPrice:0,
    estimatedPickupPrice:0,
    estimatedTotalPrice:0,

    state: -1, // -1: Requested
    type:'request',
    requestType:'',

    value:0,
    itemList:"",

    ct:1,
    boxList:[],
  }
  return item;
}
export function getNewSubItem() {
  let item = {
    name:'',
    brand:'',
    url:'',
    amount:1,
    value:'0',
    originCountry:'',
  }
  return item;
}
export function getRequestTypeString(requestType) {
  if(requestType === 'purchasing_agent') {
    return '구매/배송 대행';
  } else if(requestType === 'personal') {
    return '개인화물';
  } else if(requestType === 'ecommerce') {
    return '전자상거래';
  }
  return 'Unknown ' + requestType;
}
export function getCustomTypeString(customType) {
  if(customType === '목') {
    return '목록통관';
  } else if(customType === '일') {
    return '일반통관';
  } else if(customType === '간') {
    return '간이통관';
  }
  return customType;
}
export function getTradeTypeString(tradeType) {
  if(tradeType === 'A') {
    return '전자상거래';
  } else if(tradeType === 'C') {
    return '일반';
  }
  return tradeType;
}
export function getReceiverTypeString(receiverType) {
  if(receiverType === '1') {
    return '개인';
  } else if(receiverType === '2') {
    return '회사';
  }
  return receiverType;
}



// WEBPACK FOOTER //
// ./src/api/item.js